import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './AuthNotification.scss';

const AuthNotification: React.FC = () => {
  const { error, isRefreshing, clearError, globalErrors, dismissError } = useAuth();

  if (!error && !isRefreshing && globalErrors.length === 0) {
    return null;
  }

  return (
    <div className="auth-notification">
      {isRefreshing && (
        <div className="auth-notification-item refreshing">
          <div className="spinner"></div>
          <span>Refreshing session...</span>
        </div>
      )}
      
      {error && (
        <div className="auth-notification-item error">
          <span>{error}</span>
          <button 
            className="close-button" 
            onClick={clearError}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      )}

      {globalErrors.map((errorMsg, index) => (
        <div key={index} className="auth-notification-item error">
          <span>{errorMsg}</span>
          <button 
            className="close-button" 
            onClick={() => dismissError(index)}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default AuthNotification;